import {
  spfOne,
  spfTwo,
  spfThree,
  spfFour,
  bestSellerOne,
  bestSellerTwo,
  bestSellerThree,
  bestSellerFour,
  newArrOne,
  newArrTwo,
  newArrThree,
  newArrFour,
  bag1,
  bag2,
  bag3,
  bag4,
  bag5,
  cap1,
  cap2,
  cap3,
  cap4,
  cap5,
  glass1,
  glass2,
  glass3,
  glass4,
  hp1,
  hp2,
  hp3,
  hp4,
  hp5,
  hp6,
  hp7,
  hp8,
  phone1,
  phone2,
  phone3,
  phone4,
  phone5,
  phone6,
  phone7,
  ts1,
  ts2,
  ts3,
  ts4,
  ts5,
  ts6,
} from "../assets/images/index";

// =================== NavBarList Start here ====================
export const navBarList = [
  {
    _id: 1001,
    title: "Home",
    link: "/",
  },
  {
    _id: 1002,
    title: "Shop",
    link: "/shop",
  },
  {
    _id: 1003,
    title: "About",
    link: "/about",
  },
  {
    _id: 1004,
    title: "Contact",
    link: "contact",
  },
];
// =================== NavBarList End here ======================
// =================== Special Offer data Start here ============
export const SplOfferData = [
  {
    _id: "201",
    img: spfOne,
    productName: "Cap for Boys",
    price: "35.00",
    color: "Blank and White",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: "202",
    img: newArrFour,
    productName: "Tea Table",
    price: "180.00",
    color: "Gray",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: "203",
    img: spfThree,
    productName: "Headphones",
    price: "25.00",
    color: "Mixed",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
  {
    _id: "204",
    img: spfFour,
    productName: "Sun glasses",
    price: "220.00",
    color: "Black",
    badge: true,
    des: "Lorem ipsum dolor sit amet consectetur adipisicing elit. Hic excepturi quibusdam odio deleniti reprehenderit facilis.",
  },
];
// =================== Special Offer data End here ==============

// =================== PaginationItems Start here ===============

export const paginationItems = [
  //this is new
  {
    _id: 7001,
    img: hp1,
    productName: "Headphones Originals",
    price: "350.00",
    color: "Blank and White",
    badge: true,
    rating: 2,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 5002,
    img: phone2,
    productName: "Samsung Galaxy S23 Ultra",
    price: "9800.00",
    color: "Blank and White",
    badge: false,
    rating: 2,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 5004,
    img: phone4,
    productName: "Pixel 8 Pro",
    price: "9000.00",
    color: "Blank and White",
    badge: false,
    rating: 5,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 5005,
    img: phone5,
    productName: "Pixel 8 Pro",
    price: "9000.00",
    color: "Blank and White",
    badge: false,
    rating: 5,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 5006,
    img: phone6,
    productName: "Pixel 8",
    price: "1500.00",
    color: "Blank and White",
    badge: false,
    rating: 4,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 5007,
    img: phone7,
    productName: "iPhone 13 pro",
    price: "45,00.00",
    color: "Blank and White",
    badge: false,
    rating: 5,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 6001,
    img: ts1,
    productName: "H&M Originals T-Shirt",
    price: "350.00",
    color: "Blank and White",
    badge: true,
    rating: 4,
    des: "This is Des",
    categories: "clothing",
  },
  {
    _id: 6002,
    img: ts2,
    productName: "H&M Originals T-Shirt",
    price: "250.00",
    color: "Blank and White",
    badge: true,
    rating: 3,
    des: "This is Des",
    categories: "clothing",
  },
  {
    _id: 7034,
    img: phone1,
    productName: "Samsung Galaxy S24 Ultra",
    price: "11000.00",
    color: "Blank and White",
    badge: false,
    rating: 4,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 6003,
    img: ts3,
    productName: "H&M Originals T-Shirt",
    price: "450.00",
    color: "Blank and White",
    badge: true,
    rating: 5,
    des: "This is Des",
    categories: "clothing",
  },
  {
    _id: 6004,
    img: ts4,
    productName: "H&M Originals T-Shirt",
    price: "550.00",
    color: "Blank and White",
    badge: true,
    rating: 3,
    des: "This is Des",
    categories: "clothing",
  },
  {
    _id: 6005,
    img: ts5,
    productName: "H&M Originals T-Shirt",
    price: "650.00",
    color: "Blank and White",
    badge: true,
    rating: 5,
    des: "This is Des",
    categories: "clothing",
  },
  {
    _id: 6006,
    img: ts6,
    productName: "H&M Originals T-Shirt",
    price: "350.00",
    color: "Blank and White",
    badge: true,
    rating: 2,
    des: "This is Des",
    categories: "clothing",
  },
  {
    _id: 7002,
    img: hp2,
    productName: "Headphones Originals ",
    price: "4000.00",
    color: "Blank and White",
    badge: true,
    rating: 3,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 7003,
    img: hp3,
    productName: "Headphones Originals ",
    price: "3500.00",
    color: "Blank and White",
    badge: true,
    rating: 2,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 7004,
    img: hp4,
    productName: "Headphones Originals ",
    price: "5000.00",
    color: "Blank and White",
    badge: true,
    rating: 4,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 7005,
    img: hp5,
    productName: "Headphones Originals ",
    price: "3500.00",
    color: "Blank and White",
    badge: true,
    rating: 2,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 7006,
    img: hp6,
    productName: "Headphones Originals ",
    price: "3500.00",
    color: "Blank and White",
    badge: true,
    rating: 2,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 7007,
    img: hp7,
    productName: "Headphones Originals",
    price: "7000.00",
    color: "Blank and White",
    badge: true,
    rating: 4,
    des: "This is Des",
    categories: "electronics",
  },
  {
    _id: 8001,
    img: hp8,
    productName: "Boat Hearphone",
    price: "3.00",
    color: "Blank and White",
    badge: true,
    rating: 2,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 9001,
    img: bag1,
    productName: "Zara Orginals Bag",
    price: "3500.00",
    color: "Blank and White",
    badge: true,
    rating: 4,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 99001,
    img: bag2,
    productName: "Zara Orginals Bag",
    price: "4000.00",
    color: "Blank and White",
    badge: true,
    rating: 5,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 98001,
    img: bag3,
    productName: "Zara Orginals Bag",
    price: "5000.00",
    color: "Blank and White",
    badge: true,
    rating: 4,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 89001,
    img: bag4,
    productName: "Zara Orginals Bag",
    price: "1233.00",
    color: "Blank and White",
    badge: true,
    rating: 4,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 78001,
    img: bag5,
    productName: "Zara Orginals Bag",
    price: "3453.00",
    color: "Blank and White",
    badge: true,
    rating: 3,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 12001,
    img: cap1,
    productName: "Urban Monkey Cap Originals",
    price: "3500.00",
    color: "Blank and White",
    badge: false,
    rating: 3,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 13001,
    img: cap2,
    productName: "Urban Monkey Cap Originals",
    price: "4500.00",
    color: "Blank and White",
    badge: false,
    rating: 4,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 14001,
    img: cap3,
    productName: "Urban Monkey Cap Originals",
    price: "5000.00",
    color: "Blank and White",
    badge: false,
    rating: 2,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 15001,
    img: cap4,
    productName: "Urban Monkey Cap Originals",
    price: "3250.00",
    color: "Blank and White",
    badge: false,
    rating: 5,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 19001,
    img: cap5,
    productName: "Urban Monkey Cap Originals",
    price: "350.00",
    color: "Blank and White",
    badge: false,
    rating: 2,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 24001,
    img: glass1,
    productName: "Lenskart Originals",
    price: "4500.00",
    color: "Blank and White",
    badge: false,
    rating: 5,
    des: "This is Des",
    categories: "accesories",
  },
  {
    _id: 23001,
    img: glass2,
    productName: "Lenskart Originals",
    price: "3500.00",
    color: "Blank and White",
    badge: true,
    rating: 5,
    des: "This is Des",
    categories: "accesories",
  },

  {
    _id: 21001,
    img: glass3,
    productName: "Lenskart Originals",
    price: "250.00",
    color: "Blank and White",
    badge: true,
    rating: 2,
    des: "This is Des",
    categories: "accesories",
  },

  {
    _id: 41001,
    img: glass4,
    productName: "Lenskart Originals",
    price: "450.00",
    color: "Blank and White",
    badge: true,
    rating: 4,
    des: "This is Des",
    categories: "accesories",
  },
];
// =================== PaginationItems End here =================
